import ProductSuccess from './Success';

export default ProductSuccess;
